module.exports = __webpack_public_path__ + "static/media/400293_02.49ee95ec.png";